export default function ticketDetails({ section, row, seats }) {
    let ret = '';

    if (section) {
        ret = `Section ${section}`;
    }

    if (row) {
        ret += `${ret ? ', ' : ''} Row ${row}`;
    }

    if (seats) {
        ret += `${ret ? ', ' : ''} Seats ${seats}`;
    }

    return ret;
}
